module.exports = __webpack_public_path__ + "static/bg5-93d2f4ffdc23145e9a51c104b33b5126.jpg";